import { REMOVE_ACTION_TYPES } from './action_types';
export function removePeriscope(removePeriscopeSync) {
    return {
        data: removePeriscopeSync,
        type: REMOVE_ACTION_TYPES.REMOVE_PERISCOPE
    };
}
